package com.fabiorosati.components.sections

import androidx.compose.runtime.Composable
import com.fabiorosati.components.attributes.*
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Iframe


@Composable
fun DiscographySection(
    id: String,
    title: String,
    onNotifyTop: () -> Unit = {},
) {
    HomeSection(
        id = id,
        title = title,
        backgroundImage = "/texture.jpg",
        darkBackgroundAlpha = 100,
        onNotifyTop = { onNotifyTop() },
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(10.px)
        ) {
            // Per Mari e Tempeste
            Iframe({
                iframeStyle("border-radius:12px")
                src("https://open.spotify.com/embed/album/0s8FKPjvLdAxIfyMQXIRLm?utm_source=generator&si=9188de4fcb484c3e")
                iframeWidth("100%")
                iframeHeight("352")
                frameBorder("0")
                allowfullscreen("")
                allow("autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture")
                loading("lazy")
            })

            // Di Fuoco e Terra
            Iframe({
                iframeStyle("border-radius:12px")
                src("https://open.spotify.com/embed/album/57CmwJ1wHaeuplHdc9L1Fa?utm_source=generator&si=ad7ffedd7de54f8e")
                iframeWidth("100%")
                iframeHeight("352")
                frameBorder("0")
                allowfullscreen("")
                allow("autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture")
                loading("lazy")
            })
        }
    }
}